import React from "react";
import { Grid, IconButton, Avatar } from '@material-ui/core'
import {
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText
} from "@material-ui/core";
import { RemoveCircle } from "@material-ui/icons";
import SearchUserField from "../SearchUserField";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from "@material-ui/core/Button";
import extract_user from '../../functions/extract'

class AbstractUserList extends React.Component {
  emptyUser = { name: { full: "", title: "" }, email: "" };
  constructor(props) {
    super(props);
    if (this.getStore === undefined) {
      throw new TypeError("Must override getStore");
    }
    this.state = {
      currentUser: this.emptyUser,
      users: [],
      open: false
    };
  }

  componentDidMount() {
    const users = this.getStore().listUsers();
     if(users !== undefined){
       users.then(r => {
         this.setState({ users: r.data, selected_id: 0});
       });
     }
  }

  onReset = () => {
    this.setState({
      currentUser: {
        email: "",
        id: "",
        job_title: "",
        institution: "",
        name:{
          title: "",
          full: ""
        }
      }
    })
  }

  render() {
    const { disabled } = this.props;
    const { users, currentUser } = this.state;
    return (
      <Grid container justify="space-between" direction="row" alignItems="flex-start">
        <Grid item lg={12} xl={12} md={12} sm={12} xs={12}>
          <SearchUserField
            to={currentUser}
            onChange={this.onUserChange}
            disabled={disabled}
            onReset={this.onReset}
          />
        </Grid>
        <Grid item lg={12} xl={12} md={12} sm={12} xs={12}>
          <List>
            {users.map(u => (
              <ListItem key={u.id} style={{padding:"10px 0px"}}>
                <Avatar alt="avatar" className="avatar">{u.name.full.slice(0,2)}</Avatar>
                <ListItemText primary={u.temp? u.name.full : u.name.title+' '+u.name.full} secondary={extract_user(u.email)} />
                <ListItemSecondaryAction>
                  <IconButton onClick={(e) => this.handleClickOpen(u)} style={{padding: 0}} disabled={disabled}>
                    <RemoveCircle />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </Grid>
        <Dialog
         open={this.state.open}
         onClose={this.handleClose}
       >
         <DialogTitle id="draggable-dialog-title">Confirmación</DialogTitle>
         <DialogContent>
             ¿Realmente desea eliminar al usuario de esta lista?
         </DialogContent>
         <DialogActions className="button_modal">
           <Button onClick={this.handleClose} color="primary">
             Cancelar
           </Button>
           <Button onClick={() => this.removeUser(this.state.selected_id)} color="primary">
             Eliminar
           </Button>
         </DialogActions>
       </Dialog>
      </Grid>
    );
  }

  onUserChange = f => {
    this.setState({
      currentUser: f
    });

    if (f.email !== undefined) {
      this.getStore()
        .addUser(f)
        .then(r => {
          f.delegate_id = r.data.id;
          this.setState(prevState => {
            return {
              users: [f,...prevState.users],
              currentUser: this.emptyUser
            };
          });
          //this is for shows "El usuario se agregó con éxito" when a user was added
          if(this.props.location===undefined){
            this.props.onUserAdded();
          }
        })
        .catch((error) => {
          let error_msj;
          (error.response.data.error === 'user already in group')? error_msj='El usuario ya está en el grupo' : error_msj='Error al agregar usuario';
          this.props.onUserAddedFailed(error_msj);
        })
    }
  };

  handleClickOpen = (e) => {
    this.setState({ open: true, selected_id: e});
  };

  handleClose = () => {
    this.setState({ open: false, selected_id: 0 });
  };

  removeUser = u => {
    this.getStore()
      .removeUser(u)
      .then(r => {
        this.setState(prevState => {
          return { users: prevState.users.filter(x => x.id !== u.id) };
        });
      });
      this.handleClose();
      if(this.props.location===undefined){
        this.props.onUserDeleted();
      }
  };
}

AbstractUserList.propTypes = {};
export default AbstractUserList;



// WEBPACK FOOTER //
// ./src/components/containers/AbstractUserList.js